import React, {} from 'react';
const styles = {"item":"FaqList-module__item__2BfZY","question":"FaqList-module__question__TKxPY","answer":"FaqList-module__answer__EKbEk"};
/** Questions that open to show their answer and close again, all closed at first (the browser's own expandable rows). */
export function FaqList({ items }) {
    return (React.createElement("div", { className: styles.list }, items.map((item, index) => (React.createElement("details", { key: index, className: styles.item },
        React.createElement("summary", { className: styles.question }, item.question),
        React.createElement("p", { className: styles.answer }, item.answer))))));
}
//# sourceMappingURL=FaqList.js.map